import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { BOOKING_PANEL_STEPS, useBookingPanel } from "@/features/booking/hooks/use-booking-panel";
import { BOOKINGS_TABS } from "@/features/booking/modules/client-bookings/bookings-view";
import { ClientBookings } from "@/features/booking/modules/client-bookings/client-bookings";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/my-bookings/")({
  loader: () => ({ crumb: m.booking_portal_nav_bookings() }),
  // The visit dialog lives in the URL (`bookingId`, `occurrence`, `step`), so it is linkable and
  // Back closes it.
  validateSearch: z.object({
    tab: z.enum(BOOKINGS_TABS).optional(),
    bookingId: z.string().optional(),
    occurrence: z.string().optional(),
    step: z.enum(BOOKING_PANEL_STEPS).optional(),
  }),
  component: MyBookingsPage,
});

function MyBookingsPage() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  const { bookingId, occurrenceStart, step, openBooking, closeBooking } = useBookingPanel();

  return (
    <ClientBookings
      tab={tab ?? "upcoming"}
      onTabChange={(next) =>
        void navigate({ to: "/my-bookings", search: next === "upcoming" ? {} : { tab: next }, replace: true })
      }
      bookingId={bookingId}
      occurrence={occurrenceStart}
      step={step}
      onOpenBooking={(id, options) => void openBooking(id, options)}
      onCloseBooking={() => void closeBooking()}
      onBookAgain={(target) =>
        target.eventId || !target.sessionTypeId
          ? void navigate({ to: "/events" })
          : void navigate({
              to: "/book/$specialistId",
              params: { specialistId: target.specialistId },
              search: { serviceId: target.sessionTypeId },
            })
      }
      onBook={() => void navigate({ to: "/book" })}
      onOpenSpecialist={(specialistId, search) =>
        void navigate({ to: "/book/$specialistId", params: { specialistId }, search })
      }
    />
  );
}
